export const authRoles = {
  sa: 'sa', // Only Super Admin has access
  admin: ['admin'], // Only SA & Admin has access
  store_manager: ['admin', 'store_manager'], // Only SA & Admin & Editor has access
  cs: ['admin', 'cs'], // Only SA & Admin & Editor has access
  scs: ['admin', 'scs'], // Only SA & Admin & Editor has access
  sales: ['admin', 'sales'], // Only SA & Admin & Editor has access
  sales_manager: ['admin', 'sales_manager'], // Only SA & Admin & Editor has access
  hamrahtel: ['admin', 'hamrah_tel'], // Only SA & Admin & Editor has access
  finance: ['admin', 'finance'], // Only SA & Admin & Editor has access
  insurance_manager: ['admin', 'insurance_manager'], // Only SA & Admin & Editor has access
  agent: ['admin', 'agent'], // Only SA & Admin & Editor has access
};
